import { Image } from "react-bootstrap";

const CircleCard = ({ data }) => {
    return (
        <>
            {data &&
                data.map((d, index) => (
                    <div
                        key={index}
                        className={`col-sm-12 d-flex justify-content-center align-items-center  circle_cardHere ${window.innerWidth > 992 && window.innerWidth < 1200 && index === 3
                            ? "ml-circle"
                            : ""
                            }`}
                    >
                        <div className="circular_card" data-aos="zoom-out-up" data-aos-duration={d.delay}>
                            <div className="card_contain">
                                <div className="d-flex justify-content-center align-items-center">
                                    <Image src={d.icon} alt="icon" className="img_css" />
                                </div>
                                <p>
                                    <span dangerouslySetInnerHTML={{ __html: d.name }} />
                                </p>
                            </div>
                        </div>
                        {/* {
                            "name": "<span>Information  <br />  Technology</span>",
                        "icon": "https://toppng.com/uploads/thumbnail/technology-icon-orange-information-technology-icon-11553531011uokhdqszww.png",
                        "delay": "200"
     } */}
                    </div>
                ))}

        </>
    )
}

export default CircleCard
